export var doc = {
    content: 'block+',
};
